export const SEARCH_ORGANIZATION_MODAL_EVENT = 'modals:organizations:search';
export const SEARCH_ORGANIZATION_MODAL_OPEN = `${SEARCH_ORGANIZATION_MODAL_EVENT}:open`;
export const SEARCH_ORGANIZATION_MODAL_CLOSE = `${SEARCH_ORGANIZATION_MODAL_EVENT}:close`;
